/**
 * Volunteers management page.
 * DynamicRoleGroup wrapper for the volunteers role group.
 */

import * as React from 'react';
import { DynamicRoleGroupManagementPage } from '@/components/common/DynamicRoleGroupManagementPage';
import { VOLUNTEER_TAB_COLORS } from '@/components/volunteers/volunteer-configs';
import { VolunteersDataTable } from '@/components/volunteers/VolunteersDataTable';
import { CreateVolunteerView } from '@/components/volunteers/CreateVolunteerView';
import { EditVolunteerView } from '@/components/volunteers/EditVolunteerView';

/** Thin wrapper around {@link DynamicRoleGroupManagementPage} with volunteer-specific table / forms. */
export const VolunteersManagementPage: React.FC = () => (
  <DynamicRoleGroupManagementPage
    interfaceName="volunteers"
    menuId="menu-volunteers"
    title="Gestion des Volontaires"
    subtitle="Créez, modifiez et gérez tous vos volontaires"
    createLabel="Créer un volontaire"
    userQueryKey="volunteer"
    tabsAriaLabel="Filtrage par rôle VSC"
    allTabColor={VOLUNTEER_TAB_COLORS.all}
    renderDataTable={({
      viewMode,
      onViewModeChange,
      expandedRowId,
      onToggleRow,
      onCloseDetails,
      onEdit,
      enableFilters,
      enabledRoles,
      pageActions,
    }) => (
      <VolunteersDataTable
        viewMode={viewMode}
        onViewModeChange={onViewModeChange}
        expandedRowId={expandedRowId}
        onToggleRow={onToggleRow}
        onCloseDetails={onCloseDetails}
        onEditVolunteer={onEdit}
        enableFilters={enableFilters}
        enabledRoles={enabledRoles}
        pageActions={pageActions}
      />
    )}
    renderCreateView={({ onClose, onSuccess, initialRole }) => (
      <CreateVolunteerView onClose={onClose} onSuccess={onSuccess} initialRole={initialRole} />
    )}
    renderEditView={({ editId, onClose, onSuccess }) => (
      <EditVolunteerView
        key={editId}
        volunteerId={editId}
        onClose={onClose}
        onSuccess={onSuccess}
      />
    )}
  />
);
